<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs"/>

    <rp-password-form
      @submit="submit"
      v-model="form"/>

    <rp-overlay :active="active">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction">
      </rp-alert>
    </rp-overlay>
  </div>
</template>

<script>
import {paswordResetUpdate} from 'raypro_ui/src/api/users'

import PasswordForm from 'raypro_ui/src/components/ui/forms/ForgotPasswordForm'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'

import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    'rp-password-form': PasswordForm,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    Breadcrumbs
  },

  data() {
    return {
      form: {
        new_password: '',
        confirm_new_password: ''
      },
      active: false,
      successMessage: 'Your password has been changed. You will now be redirected to the login page.',
      breadcrumbs: [
        {label: 'Reset Password'},
        {label: 'Password'}
      ]
    }
  },

  mixins: [page],

  computed: {
    payload() {
      const user = {password: this.form.new_password}

      return {
        resetToken: this.$route.params.token,
        data: {user}
      }
    }
  },
  methods: {
    successFunction() {
      this.$router.push({name: 'Login'})
    },

    submit() {
      paswordResetUpdate(this.payload).then(() => {
        this.active = true
      })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Password/ForgotPasswordForm.vue